<template>
  <div class="">
    <div class="store-based-marketing-title">
      <CustomBreadcrumb/>
    </div>

    <div class="shopVidi-campaigns">
          <p>ShopVidi EDM/SMS Campaigns</p>
          <p>Schedule and send messages to a segment of customers.</p>
          <div class="tips-area">
            <div>
              <img src="@/assets/img/marketing/boost-your-sales.png">
              <span>Boost your sales</span>
            </div>
            <div>
              <img src="@/assets/img/marketing/use-alto-create-copy.png">
              <span>Use Alto create copy</span>
            </div>
            <div>
              <img src="@/assets/img/marketing/create-seasonal-promotion.png">
              <span>Create a seasonal promotion</span>
            </div>
          </div>
          <div class="btn" @click="create">Create Campaigns</div>
    </div>

    <p>EDM /SMS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
    <div class="table-list">
      <el-table ref="edmTable" :data="tableData" style="width: 100%">
        <el-table-column
          prop="campaignName"
          label="Name"
          width="200">
          <template slot-scope="scope">
            <div class="fontBond campaign-name-"  @click="clickDetail(scope.row,'openRate',true)">
              {{scope.row.campaignName || '-' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Total Stores"
          width="200">
          <template slot-scope="scope">
              <p v-for="(itm,i) in scope.row['marketingStoreTypeList']" :key="i">
                  <span>{{itm.storeType}}</span>
                  (<span v-format="'#,##'" style="color: #FB541C;">{{itm.count}}</span>)
              </p>
           </template>
        </el-table-column>

        <el-table-column
          prop="marketingCycle"
          label="Marketing Cycle"
          width="120">
          <template slot-scope="scope">
            <p> {{scope.row.marketingCycle}} </p>
            <p>{{scope.row.cycleStartTime}}-{{scope.row.cycleEndTime}}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="Status"
          width="100">
          <template slot-scope="scope">
            <span style="color: #41B76A;font-weight: 500;">{{scope.row.status===0?'Not Effective':'Effective'}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="marketingBatch"
          label="Marketing Batch"
          width="110">
          <template slot-scope="scope">
              <div class="batch-field" v-if="scope.row.marketingBatch">{{scope.row.marketingBatch}}</div>
              <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="sendTime"
          label="Send time"
          width="130">
          <template slot-scope="scope">
            <template v-if="scope.row.sendTime">{{scope.row.sendTime}}</template>
            <template v-else>-</template>
          </template>
        </el-table-column>

        <el-table-column
          prop="marketingType"
          label="Maketing Type"
          width="180">
          <template slot-scope="scope">
            {{scope.row['marketingType'] | filterMaketingType}}
          </template>
        </el-table-column>

        <el-table-column
          prop="deliveryRate"
          label="Delivery rate"
          width="150">
          <template slot-scope="scope" >
            <template v-if="scope.row['deliveryRecipients'] && scope.row['deliveryRecipients']>0">
              <p v-format="'0.00%'">{{ scope.row['deliveryRate'] }}</p>
              <p style="color: #2866FF;">
                <span v-format="'#,##'">{{ scope.row['deliveryRecipients'] }}</span>
                <span>Total recipients</span>
              </p>
            </template>
            <template v-else>
              -
            </template>
          </template>

        </el-table-column>

        <el-table-column
          prop="openRate"
          label="Open rate"
          width="130">
          <template slot-scope="scope" >
            <template v-if="scope.row['openRecipients'] && scope.row['openRecipients']>0">
              <p v-format="'0.00%'">{{ scope.row['openRate'] }}</p>
              <p style="color: #2866FF;cursor: pointer;" @click="clickDetail(scope.row,'openRate')">
                <span v-format="'#,##'">{{ scope.row['openRecipients'] }}</span>
                <span>recipients</span>
              </p>
            </template>
            <template v-else>
              -
            </template>
          </template>

        </el-table-column>

        <el-table-column
          prop="clickRate"
          label="Click rate"
          width="150">
          <template slot-scope="scope" >
            <template v-if="scope.row['clickRecipients'] && scope.row['clickRecipients']>0">
            <p v-format="'0.00%'">{{ scope.row['clickRate'] }}</p>
            <p style="color: #2866FF;cursor: pointer;" @click="clickDetail(scope.row,'clickRate')">
              <span v-format="'#,##'">{{ scope.row['clickRecipients'] }}</span>
              <span>recipients</span>
            </p>
            </template>
            <template v-else>-</template>
          </template>

        </el-table-column>

        <el-table-column
          prop="viewedProduct"
          label="Viewed Product"
          width="150">
          <template slot-scope="scope" >
            <template v-if="scope.row['viewProductAmount'] && scope.row['viewProductAmount']>0">
              <p v-format="'$#,##.##'">{{ scope.row['viewProductAmount'] }}</p>
              <p style="color: #2866FF;cursor: pointer;" @click="clickDetail(scope.row,'viewProduct')">
                <span v-format="'#,##'">{{ scope.row['viewProductRecipients'] }}</span>
                <span>recipients</span>
              </p>
            </template>
            <template v-else>
              -
            </template>
          </template>

        </el-table-column>


        <el-table-column
          prop="addToCartAmount"
          label="Added to Cart"
          width="110">
          <template slot-scope="scope">
            <template  v-if="scope.row['addToCartAmount'] && scope.row['addToCartAmount']>0">
              <p v-format="'$#,##.##'">{{ scope.row['addToCartAmount'] }}</p>
              <p style="color: #2866FF;cursor: pointer;" @click="clickDetail(scope.row,'addToCart')">
                <span v-format="'#,##'">{{ scope.row['addToCartRecipients'] }}</span>
                <span>recipients</span>
              </p>
            </template>
            <template v-else>-</template>
          </template>

        </el-table-column>


        <el-table-column
          label="Operate"
          width="90">
          <template slot-scope="scope" v-if="scope.row['showOperation']">
              <span style="cursor: pointer;"  @click="clickDetail(scope.row,'openRate')">Views</span>
          </template>

        </el-table-column>



      </el-table>
    </div>

    <Pagination
      :currentPage="query.pageNo"
      :total="total"
      :pageSize="query.pageSize"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></Pagination>

  </div>
</template>

<script>
import CustomBreadcrumb from '../components/custom-breadcrumb'
import {getAction} from "../../api/manage";
import Pagination from "../components/pagination";

let typeMap = new Map([['1','EMAIL'],['2','SMS'],['3','EMAIL+SMS']])


export default {
  components: {
    CustomBreadcrumb,
    Pagination
  },
  data(){
    return {
      tableData:[
        {
          "openRate":0.155,
          "openRecipients":549,
          "marketingType":"3",
          "addToCartAmount":3500,
          "addToCartRecipients":9,
          "deliveryRecipients":3000,
          "deliveryRate":0.845,
          "marketingBatch":1,
          "cycleStartTime":"2023/01/01",
         "viewProductAmount":29328.70,
          "viewProductRecipients":78,
          "showOperation":true,
          "sendTime":"2023/01/05 10:21",
          "cycleEndTime":"2024/03/30",
          "clickRecipients":247,
          "clickRate":0.082,
          "marketingCycle":"One quarter, 6 marketing campaigns.",
          "marketingStoreTypeList":[
            {
              "storeType":"Al-Powered Shop Recommendations",
              "count":3000,
              "marketingId":"1747185772372598785"
            }
          ],
          "id":"1747185772372598785",
          "campaignName":"【This is a marketing example】",
          "status":1,
          "marketingBatchId":"2"
        }
      ],
      bindFirstBrandObj:{},
      total: 0,
      query: {
        pageNo: 1,
        pageSize: 20,
      },

    }
  },
  created() {
    this.loadFirstBrand()
    this.loadData()
  },
  filters:{
    filterMaketingType(v){
      return typeMap.get(v)
    }
  },
  methods: {
    clickDetail(row,type,flag){
      if(flag ){
        return;
      }

      this.$router.push({
        path: 'store-based-marketing-detail', query: {
          campaignName: row.campaignName,
          selectedTab: type,
          openRatePercent: row.openRate ? this.textFormat(row.openRate, '0.##%') : '0%',
          clickRatePercent: row.clickRate ? this.textFormat(row.clickRate, '0.##%') : '0%',
          viewProduct: row.viewProductRecipients ? this.textFormat(row.viewProductRecipients, '#,##') : 0,
          addToCart: row.addToCartRecipients ? this.textFormat(row.addToCartRecipients, '#,##') : 0,
          marketingId: row.id,
          marketingBatch: row.marketingBatch,
        }
      })

    },
    loadData() {
      this.loading = true
      getAction(`/marketing/activity/api/v0.2/list`, this.query).then(response => {
        if (response.success && response.result !== null) {
          this.total = response.result.total
          if (this.total > 0) {
            const records = response.result.records || []

            this.tableData = records
            this.query.pageNo = response.result.current
            this.query.pageSize = response.result.size
          }else{
            this.total = 1
          }
          this.loading = false
        } else {
          this.loading = false
          this.$message.warning(response.message)
        }
      })

    },
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNo = 1
      this.loadData()
    },
    handleCurrentChange(currentPage) {
      this.query.pageNo = currentPage
      this.loadData()
    },
    loadFirstBrand() {
      getAction(`/sp/suppliers/bind-brand`).then(res => {
          if (res.success) {
              this.bindFirstBrandObj = res['result']
          }

      })
    },
     create() {
       if (this.bindFirstBrandObj == null || Object.keys(this.bindFirstBrandObj ).length === 0) {
         this.$message.info("Your account is not yet linked to a brand, so you are currently unable to create marketing campaigns.")
         return;
       }
       this.$router.push({path: 'create-store-based-marketing', query: {brandName: this.bindFirstBrandObj.brandName}})
    },

  }
}
</script>

<style lang="less" scoped>
.store-based-marketing-title {
  font-size: 14px;
  font-weight: 600;
  color: #262B2F;
  margin: 10px 0px 20px 0px !important;
}
.shopVidi-campaigns{
  border: 1px solid #E1E1E1;
   color: #000000;
  text-align: center;
  p:nth-child(1){
    font-size: 18px;
    font-family: Satoshi-Bold !important;
    margin-top: 30px;
  }
  p:nth-child(2){
    margin-top: 10px;
  }

  .tips-area{
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 60%;
    margin: 35px auto 20px;

  }

  .tips-area img{
    width: 48px;
    height: 48px;
  }
  .tips-area span{
    font-family: Satoshi-Bold !important;
    position: relative;
    top: -18px;
    margin-left: 10px;
  }

  .btn{
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    width: 220px;
    background: #000000;
    color: #FFFFFF;
    margin: 0 auto;
    font-family: Satoshi-Bold !important;
  }
  .btn{
    margin-bottom: 40px;
  }

}
.shopVidi-campaigns + p{
  font-size: 14px;
  font-family: Satoshi-Bold !important;
  margin: 18px 0 0;
  padding-left: 5px;
  text-decoration: underline;
  text-underline-offset: 15px;
  text-decoration-thickness: 2px;
  text-decoration-color: #262B2F;
 }

.table-list{
  margin-top: 12px;
  border: 1px solid #E1E1E1;
}

.el-table .cell,.font-satoshi{
  font-family: Satoshi !important;
  font-size: 14px;
}
.fontBond{
  font-family: Satoshi-Bold !important;
}
.batch-field{
  border-radius: 2px;
  background: #262B2F;
  padding: 2px 5px;
  color: #FFFFFF;
  font-weight: 500;
  text-align: center;
}
.campaign-name{
  text-decoration: underline;
  cursor:pointer;
}

.table-list /deep/ .el-table__body tr .cell{
  color: #000000 !important;
  font-weight: unset !important;
  font-family: Satoshi !important;
}
.table-list /deep/ .has-gutter th .cell{
  font-family: Satoshi-Bold !important;
  color: #000000 !important;
  font-weight: unset !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/store-based-marketing/store-based-marketing-list.vue